import { useEffect, useState } from 'react'
import {
  getLocalRecentCarHireSearches,
  type RecentCarHireSearch,
} from 'components/CarHire/carHireRecentSearches'

function useRecentCarHireSearches() {
  const [recentSearches, setRecentSearches] = useState<Array<RecentCarHireSearch>>([])

  useEffect(() => {
    setRecentSearches(getLocalRecentCarHireSearches())
  }, [])

  return recentSearches
}

export default useRecentCarHireSearches
